/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Calendar_Event_Case_Line_No_PlateInputs */

const en_calendar_event_case_line_no_plate = /** @type {(inputs: Calendar_Event_Case_Line_No_PlateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case ${i?.caseNumber}`)
};

const pt_br2_calendar_event_case_line_no_plate = /** @type {(inputs: Calendar_Event_Case_Line_No_PlateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso ${i?.caseNumber}`)
};

/**
* | output |
* | --- |
* | "Case {caseNumber}" |
*
* @param {Calendar_Event_Case_Line_No_PlateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_event_case_line_no_plate = /** @type {((inputs: Calendar_Event_Case_Line_No_PlateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Event_Case_Line_No_PlateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_event_case_line_no_plate(inputs)
	return pt_br2_calendar_event_case_line_no_plate(inputs)
});